import * as React from 'react'

/**
 * @description Warning icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Warning } from '@sravni/design-system-icons'
 *
 * <Warning />
 * ```
 */
export const Warning = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Warning" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m2.257 14.765 6.436-11.44a1.5 1.5 0 0 1 2.614 0l6.435 11.44A1.5 1.5 0 0 1 16.436 17H3.565a1.5 1.5 0 0 1-1.308-2.235ZM9.996 13a1 1 0 1 0 .009 2 1 1 0 0 0-.009-2Zm-.444-6a.5.5 0 0 0-.497.55l.4 4a.5.5 0 0 0 .497.45h.095a.5.5 0 0 0 .498-.45l.4-4a.5.5 0 0 0-.498-.55h-.895Z"
      fill="currentColor"
    />
  </svg>
))
